export default "/images/vendor/flag-icon-css/flags/1x1/ua.svg?877b33447e5924f4f2468ffb96dbd452";